import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <div className="w-9 h-9 flex items-center justify-center">
              <i className="ri-book-open-line text-2xl text-primary-500"></i>
            </div>
            <span className="text-lg font-semibold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
              韩漫大全
            </span>
          </Link>

          <div className="hidden lg:flex items-center gap-1">
            {categories.slice(1, 6).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-3 py-2 rounded-lg text-sm whitespace-nowrap transition-colors cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/category/all"
              className={`px-3 py-2 rounded-lg text-sm whitespace-nowrap transition-colors cursor-pointer ${
                location.pathname === '/category/all'
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-600 hover:bg-background-100'
              }`}
            >
              更多 <i className="ri-arrow-down-s-line text-xs"></i>
            </Link>
          </div>

          <div className="hidden lg:flex items-center gap-3">
            <Link
              to="/about"
              className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
            >
              关于我们
            </Link>
          </div>

          <button
            className="lg:hidden w-9 h-9 flex items-center justify-center cursor-pointer"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-foreground-950`}></i>
          </button>
        </div>
      </nav>

      {isMobileMenuOpen && (
        <div className="lg:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-2">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm transition-colors cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className={`${cat.icon} text-sm`}></i>
                </div>
                {cat.name}
              </Link>
            ))}
            <div className="border-t border-background-200 pt-2 mt-1">
              <Link
                to="/about"
                className="flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-foreground-600 hover:bg-background-100 transition-colors cursor-pointer"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-information-line text-sm"></i>
                </div>
                关于我们
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}